import { makeStyles } from "@material-ui/core/styles";

export const useStyle = makeStyles((theme) => ({
  input: {
    ...theme.typography.body2,
    background: "none",
    border: "none",
    width: "100%",
    cursor: "pointer",
    color: theme.palette.grey[700],
    fontSize: "0.875rem",
    "&:focus": {
      height: "1.188rem",
      color: theme.palette.grey[700],
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(3),
      cursor: "initial",
      boxSizing: "border-box",
    },
    "&:disabled": {
      cursor: "initial",
      color: theme.palette.grey[700],
      fontSize: "0.875rem",
    },
  },
}));
